export default __webpack_public_path__ + "static/media/rent.e7dbd9d2.png";